export default __webpack_public_path__ + "static/10.logo_monochrome_white-bg-f505bc303df96e27ee2b32bbf8252083.svg";